import { CHANGE_STORE_MODAL_OPEN, CHANGE_STORE_MODAL_IS_LOADING, CHANGE_STORE_MODAL_SET_STORES } from "../actions/changeStoreModal";
import moment from "moment";

const defaultState = {
    isOpen: false,
    isLoadingNewStore: false,
    date: moment(),
    covers: 2,
    isLoadingStores: false,
    availableStores: [],
}

export const changeStoreModalReducer = (state = defaultState, action) => {
    switch (action.type) {
        case CHANGE_STORE_MODAL_OPEN: {
            return { ...state, isOpen: action.isOpen, isLoadingNewStore: false , date: action.date, covers: action.covers, isLoadingStores: true }
        }
        case CHANGE_STORE_MODAL_IS_LOADING: {
            return { ...state, isLoadingNewStore: action.isLoading }
        }
        case CHANGE_STORE_MODAL_SET_STORES: {
            return { ...state, isLoadingStores: false, availableStores: action.stores }
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/changeStoreModal.js